import styled from 'styled-components'

export const Separator = styled.div`
  padding-top: 15px;
  font-weight: bold;
  font-size: 16px;
  border-bottom: solid #a2a2a2 1px;
  margin-bottom: 24px;
  color: #58585d;
`